import { Injectable } from '@angular/core';


declare let ttq: any;

@Injectable({
  providedIn: 'root'
})
export class TiktokPixelService {

  constructor() { }


  public tiktokViewContent(){
    ttq.track('ViewContent')
  }

  public contactPixel(){
    ttq.track('Contact')
  }


}
